import React, { Fragment } from 'react';
import { formatCurrencyNumber } from '../../../Common/format';

const Installment = ({ payments, baseAmount, totalAmount, promotionalTicket, totalWithDiscount}) => {

    return (
        <Fragment>
            <h6 className="text-muted text-uppercase">Pagamento</h6>
            <div>

            { payments.forEach(payment => {
            })}
                <small className="text-uppercase text-muted">Total Débitos </small>
                <span className="w-150px d-inline-block fw-400">R$ {formatCurrencyNumber(baseAmount)}</span>
            </div>
            <div>
                {payments.map(function(payment, key){
                    if(!promotionalTicket){
                        return ([
                            <small className="text-uppercase text-muted">Parcelamento </small>,
                            <span className="w-150px d-inline-block fw-400" key={ payment.id }>{payment.installments}x R$ {formatCurrencyNumber(payment.installmentsAmount)}</span>,
                            <br/>

                        ]);
                    } else {
                        return ([
                            <small className="text-uppercase text-muted">Parcelamento </small>,
                            <span className="w-150px d-inline-block fw-400" key={ payment.id }>{payment.installments}x R$ {formatCurrencyNumber(totalWithDiscount/payment.installments)}</span>,
                            <br/>

                        ]);
                    };
                })}
            </div>

            <hr className="hr-sm w-50 mr-0" />

            <h4 className="text-uppercase">
                <strong className="fs-14">Total Pago </strong>
                <div className="w-150px d-inline-block text-info">
                {!promotionalTicket ?
                    <span className="fw-500 fs-20">R$ {formatCurrencyNumber(totalAmount)}</span>
                :
                    <span className="fw-500 fs-20">R$ {formatCurrencyNumber(totalWithDiscount)}</span>

                }

                </div>
            </h4>
        </Fragment>
    );
}

export default Installment;


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/Installment.js